export default function () {
  return {
    authenticated: false,
    profile: null,
    is_focused_power_dialer: false,
    loading: false
  }
}
